import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { ZapIcon } from 'lucide-react';
export function UrgencyBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="fixed top-0 left-0 w-full bg-electric-blue z-50 px-4 py-3 shadow-glow-blue" data-id="element-266">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3 text-sm md:text-base" data-id="element-267">
        <div className="flex items-center gap-2 font-medium text-white text-center md:text-left" data-id="element-268">
          <ZapIcon className="w-5 h-5 text-gold fill-gold" data-id="element-269" />
          <span className="hidden md:inline" data-id="element-270">
            OFERTA LIMITADA — Solo por hoy el pack completo con todos los bonos
          </span>
          <span className="md:hidden" data-id="element-271">OFERTA LIMITADA — Solo por hoy</span>
        </div>

        <div className="font-heading font-bold text-xl text-white tracking-wider" data-id="element-272">
          {hours}:{minutes}:{seconds}
        </div>

        <div className="flex items-center gap-4" data-id="element-273">
          <span className="hidden lg:inline text-white/90" data-id="element-274">
            Quedan pocas unidades al precio especial
          </span>
          <a href="#checkout" className="bg-deep-black text-gold font-bold px-4 py-1.5 rounded-full hover:bg-black transition-colors border border-gold/30 shadow-glow-gold text-sm whitespace-nowrap" data-id="element-275">
            QUIERO EL PACK →
          </a>
        </div>
      </div>
    </div>;
}